<template>
	<div class="container__contentheader">
		<div class="container__contentheader__content">
			<slot />
		</div>
	</div>
</template>

<script>
export default {}
</script>

<style scped>
.container__contentheader {
	background-color: white;
	width: 100%;
	height: auto;
}

.container__contentheader__content {
	max-width: 1200px;
	padding: 0 2rem 4rem 2rem;

	height: auto;
	margin: 0 auto;
}

@media screen and (min-width: 1200px) {
	.container__contentheader__content {
		padding: 0 0 4rem 0;
	}
}
</style>
